/** @format */

export enum MyAccountSummaryDrawerType {
  GOLD,
  POINTS,
  SC_PLUS,
  PROMO,
  BENEFIT,
}
